<template>
	<div>
		<div class="list_box small_hand" v-for="(item, index) in count" :key="index" @click="goDeatil(item.id)">
			<div class="two-overflow type_size_22">
				{{item.question_title}}
			</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20"  v-show="type == 0">
				<div class="p_flex p_f_1 one-overflow p_m_r_30">{{item.jobSubmit.job_name}}</div>
				<div class="p_flex type_size_16">
					<span class="subject_color">{{item.classLevel.name}}</span>
					<el-divider direction="vertical"></el-divider>
					<span class="subject_yellow">{{item.subject_def}}</span>
				</div>
			</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20" v-show="type == 1">
				<div class="p_flex p_f_1 one-overflow p_m_r_30">{{item.jobSubmit.job_name}}</div>
				<div class="p_flex type_size_16">
					<span class="subject_color">{{item.classLevel.name}}</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{item.student.name}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			count: [],
			loading: false
		};
	},
	props: {
		type: {
			type: String
		}
	},

	mounted() {
		this.get()
	},
	methods: {
		get(id) {
			this.$request
				.ajax(this)
				.post('/api_teacher/wrong_question_list', {
					wrong_correct_status: this.type == 0 ? 2 : 1 //1.待批改，2.已订正
				})
				.then(res => {
					this.count = res.data.list;
					console.log(res,'列表')
				});
		},
		goDeatil(id){
			this.$emit('goDeatils',id)
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/wrong/commponents/detailList.vue